export const formatDate = (dateString?: string | null) => {
    if (!dateString) return '-';
    return new Date(dateString).toLocaleDateString('pt-BR', { timeZone: 'UTC' });
};

export const calculateElapsedTime = (startDate: string, endDate: string) => {
    if (!startDate || !endDate) return '-';
    const start = new Date(startDate);
    const end = new Date(endDate);
    let years = end.getUTCFullYear() - start.getUTCFullYear();
    let months = end.getUTCMonth() - start.getUTCMonth();
    let days = end.getUTCDate() - start.getUTCDate();

    if (days < 0) {
        months--;
        days += new Date(end.getUTCFullYear(), end.getUTCMonth(), 0).getDate();
    }
    if (months < 0) {
        years--;
        months += 12;
    }

    return `${years} anos, ${months} meses, ${days} dias`;
};

export const calculateTimePassed = (startDate: string, endDate: string) => {
    if (!startDate || !endDate) return '-';
    const start = new Date(startDate);
    const end = new Date(endDate);
    const now = new Date();
    const limitDate = now > end ? end : now;

    if (limitDate < start) {
        return '0 anos, 0 meses, 0 dias';
    }

    let years = limitDate.getUTCFullYear() - start.getUTCFullYear();
    let months = limitDate.getUTCMonth() - start.getUTCMonth();
    let days = limitDate.getUTCDate() - start.getUTCDate();

    if (days < 0) {
        months--;
        days += new Date(limitDate.getUTCFullYear(), limitDate.getUTCMonth(), 0).getDate();
    }
    if (months < 0) {
        years--;
        months += 12;
    }

    return `${years} anos, ${months} meses, ${days} dias`;
};

export interface DeadlineInfo {
    isOverdue: boolean;
    daysOverdue: number;
    daysRemaining: number;
    label: string;
}

export const getDeadlineInfo = (endDate?: string | null, status?: string): DeadlineInfo => {
    if (!endDate) {
        return { isOverdue: false, daysOverdue: 0, daysRemaining: 0, label: 'Sem prazo definido' };
    }

    const now = new Date();
    const todayUtc = Date.UTC(now.getFullYear(), now.getMonth(), now.getDate());
    const [year, month, day] = endDate.split('T')[0].split('-').map(Number);
    const endUtc = Date.UTC(year, (month || 1) - 1, day || 1);

    const diffDays = Math.round((endUtc - todayUtc) / (1000 * 60 * 60 * 24));
    const isCompleted = status === 'Concluída' || status === 'Finalizada';

    if (isCompleted) {
        return {
            isOverdue: false,
            daysOverdue: 0,
            daysRemaining: Math.max(0, diffDays),
            label: 'Concluída',
        };
    }

    if (diffDays < 0 && status === 'Em Andamento') {
        const overdue = Math.abs(diffDays);
        return {
            isOverdue: true,
            daysOverdue: overdue,
            daysRemaining: 0,
            label: `Prazo vencido há ${overdue} ${overdue === 1 ? 'dia' : 'dias'}`,
        };
    }

    return {
        isOverdue: false,
        daysOverdue: 0,
        daysRemaining: Math.max(0, diffDays),
        label: 'No prazo',
    };
};

export const getTimeProgressPercent = (startDate?: string | null, endDate?: string | null): number => {
    if (!startDate || !endDate) return 0;
    const start = new Date(startDate).getTime();
    const end = new Date(endDate).getTime();
    const now = Date.now();
    if (end <= start) return 100;
    if (now <= start) return 0;
    return Math.min(100, Math.max(0, ((now - start) / (end - start)) * 100));
};
